import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ApprovalLevelChain } from 'components/ApprovalLevelChain';

import messages from './messages';
import { useStyles } from './styles';
import { RuleGroup } from './types';

interface ApproverRailProps {
  rules: RuleGroup[];
  /** Whether the request has finished — see `levelState`. */
  requestSettled: boolean;
}

/**
 * The offer decision dialog's sidebar: "Approvers" over the level chain. The
 * heading leaves out "Offer" because the panel is already an offer.
 *
 * A heading and nothing else — the chain itself is
 * `components/ApprovalLevelChain`, shared with the recruiter read-only view (§10,
 * AXHE-3912) and AXHE-3948's progress panel. It used to render the tree here, and
 * that copy read every `skipped` level as "did not apply" — false for the sibling
 * levels a rejection closes (`Approvals::RecordDecision#close_co_active_steps`),
 * and the reason the derivation now lives in one place.
 */
export const ApproverRail: React.FC<ApproverRailProps> = ({
  rules,
  requestSettled,
}) => {
  const styles = useStyles();

  return (
    <div className={classNames(styles.railSection, styles.approversSection)}>
      <Typography variant="h4">
        <FormattedMessage {...messages.approversHeading} />
      </Typography>

      {/* Named only when several rules gate the offer — with one, the name is a
          heading over the whole rail that repeats what the rail already is.
          Compact and identity-only because the design draws each approver as
          a name and an answer, with no address and no pill beside a level's
          name; the dates stay. */}
      <ApprovalLevelChain
        compact
        identityOnly
        rules={rules}
        requestSettled={requestSettled}
        showRuleNames={rules.length > 1}
      />
    </div>
  );
};
